import { createCRUDHook } from './createCRUDHook';
import { DieBoardServiceDateDto } from 'utils/models';
import { TBL_DIE_BOARD_SERVICE_DATE } from './apiEndPoints';

const { Context, useManager, useConsumer } =
  createCRUDHook<DieBoardServiceDateDto>({
    entityName: 'DieBoardServiceDate',
    endpoint: TBL_DIE_BOARD_SERVICE_DATE,
  });

export const DieBoardServiceDateContext = Context;
export const useDieBoardServiceDateManager = useManager;
export const useDieBoardServiceDate = useConsumer;
